
//全局调用方法
export default {
  // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
	install: function (Vue) {
    /* Vue.prototype.$queryUserAllInfo = function(token){
      let phSessionToken = ''
      if(token){
        phSessionToken = token
      }else{
        return false
      }
      //获取用户完整权限信息
      let params = {
        phSessionToken: token
      }
      this.$api.systemModule.queryUserAllInfo.post(`queryUserAllInfo`, params)
        .then(res => {
          if(res.data.retcode === 1) {
              let data = res.data.data;
              //存在localStorage
              localStorage.setItem("functions", JSON.stringify(data.functions));
            }
          })
          .catch(err => {
            console.log(err)
          })
    } */
    //首次进入页面都重置分页为1
    Vue.prototype.$resetPaginations = function (){
      return this.$config.paginationParams = {
        pageNo: 1,
        pageSize: 5
      }
		}
		//图片预览
    Vue.prototype.$viewerShowImg = function (className){
      const viewer = this.$el.querySelector(className).viewer
      viewer.show()
		}
	    //返回上一页
		Vue.prototype.$back = function(){
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
      //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
    //如果上面都执行了 页面都跳走了，这个也就不用管了
      setTimeout(() => {
          this.$router.push({path:'/'})
      },500)
    }
		//校验手机号
    Vue.prototype.$checkMobile = (rule, value, callback) => {
      if(value === ''){
        callback(new Error('手机号不能为空'))
      }else{
        let reg = /^1[3456789]\d{9}$/
        if(!reg.test(value)){
          callback(new Error('请输入有效的手机号码'))
        }
        callback()
      }
		}
    //校验座机
    Vue.prototype.$checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('座机不可为空'))
      } else {
      if (value !== '') {
        let reg = /^\d{3,4}-?\d{7,9}$/
        if(!reg.test(value)){
          callback(new Error('请输入正确的座机格式'))
        }
      }
        callback()
      }
    }
    //校验邮箱
		Vue.prototype.$checkEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请正确填写邮箱'))
      } else {
        if (value !== '') {
          let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if(!reg.test(value)){
                callback(new Error('请输入有效的邮箱'))
          }
        }
        callback()
      }
		}
	}
}
//判断列表状态
/* export function findName(arr = [], id) {
  let value = ''
  if (id === null || id === undefined) return ''
  arr.forEach(item => {
    if (id === item.id) {
      value = item.name
      return
    }
  })
  return value
}
self.list.forEach(item => {
  item.statusStr = findName(self.statusList, item.syncStatus);
});
statusList: [
        { id: 0, name: '未推送' },
        { id: 1, name: '推送成功' },
        { id: 2, name: '推送失败' },
        { id: 3, name: '业务数据校验不通过' }
      ], */



// WEBPACK FOOTER //
// ./src/utils/utils.js